import { render, staticRenderFns } from "./PageColumnWithWithdrawUpdate.vue?vue&type=template&id=d529c238&lang=pug&"
import script from "./PageColumnWithWithdrawUpdate.vue?vue&type=script&lang=ts&"
export * from "./PageColumnWithWithdrawUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PageColumnWithWithdrawUpdate.vue?vue&type=style&index=0&id=d529c238&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports